module.exports = __webpack_public_path__ + "static/media/forward-icon.c7258f95.svg";